import { render } from "./AfterMain.vue?vue&type=template&id=182e866a"
import script from "./AfterMain.vue?vue&type=script&lang=js"
export * from "./AfterMain.vue?vue&type=script&lang=js"

import "./AfterMain.vue?vue&type=style&index=0&id=182e866a&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__